// 选择器配置表
export default {

  //选择客户
  selectLaborEnt: {
    title: '选择客户',
    column: [
      { label: '客户编码', prop: 'entCode', align: 'center'},
      { label: '客户名称', prop: 'entName', align: 'center'},
    ],
    search: [
      { label: '客户编码', key: 'entCode'},
      { label: '客户名称', key: 'entName'}
    ],
    api: 'api/manage/labor/list',
    id: 'entCode'
  },
  selectProject: {
    title: '选择项目',
    column: [
      { label: '项目编码', prop: 'projectCode', align: 'center'},
      { label: '项目名称', prop: 'projectName', align: 'center'},
      { label: '分包公司', prop: 'taxBaseName', align: 'center'},
    ],
    search: [
      { label: '项目名称', key: 'projectName'},
    ],
    api: '/api/manage/project',
    id: 'selectProject'
  },

  //一级代理选择
  selectOneLevelAgent: {
    title: '选择代理',
    column: [
      // { label: '代理类型', prop: 'agentType', align: 'center', slectKey: 'AGENT_TYPE'},
      { label: '代理编码', prop: 'agentCode', align: 'center'},
      { label: '代理名称', prop: 'agentName', align: 'center'},
    ],
    search: [
      // { label: '代理类型', key: 'agentType', slectKey: 'AGENT_TYPE'},
      { label: '代理编码', key: 'agentCode'},
      { label: '代理名称', key: 'agentName'},
    ],
    api: '/api/manage/agent/list',
    id: 'selectOneLevelAgent'
  },
  selectTaxBase: {
    title: '选择代征公司',
    column: [
      { label: '代征公司编码', prop: 'taxBaseCode', align: 'center'},
      { label: '代征公司名称', prop: 'taxBaseName', align: 'center'},
    ],
    search: [
      { label: '代征公司名称', key: 'taxBaseName'},
    ],
    api: '/api/manage/org/tax/list',
    id: 'selectTaxBase'
  },
  selectOrganization: {
    title: '选择机构',
    column: [
      { label: '机构编码', prop: 'orgCode', align: 'center'},
      { label: '机构名称', prop: 'orgName', align: 'center'},
    ],
    search: [
      { label: '机构名称', key: 'orgName'},
    ],
    api: '/api/manage/org/list',
    id: 'selectOrganization'
  },
  selectSupplierWin: {
    title: '选择供应商',
    column: [
      { label: '供应商编码', prop: 'supplierCode', align: 'center'},
      { label: '供应商名称', prop: 'supplierName', align: 'center'},
    ],
    search: [
      { label: '供应商名称', key: 'orgsupplierNameName'},
    ],
    api: '/api/manage/supplier/list',
    id: 'selectSupplierWin'
  },
  selectNatural: {
    title: '选择自然人',
    column: [
      { label: '姓名', prop: 'realName', align: 'center'},
      { label: '身份证号', prop: 'certNo', align: 'center'},
      { label: '手机号', prop: 'mobileNo', align: 'center'},
    ],
    search: [
      { label: '姓名', key: 'realName'},
      { label: '身份证号', key: 'certNo'},
      // { label: '手机号', key: 'mobileNo'},
    ],
    api: '/api/manage/labor/person',
    id: 'selectNatural',
  },
	// 选择用户
	selectUser: {
	  title: '选择人员',
	  column: [
	    { label: '姓名', prop: 'realName', align: 'center'},
			{ label: '手机号码', prop: 'phone', align: 'center'},
	    { label: '角色', prop: 'roleNames', align: 'center'},
	  ],
	  search: [
	    { label: '姓名', key: 'realName'},
	  ],
	  api: '/api/enuser/list',
	  id: 'selectUser'
	},
	// 选择私车公用企业员工
	selectCarStaff: {
	  title: '私车公用企业员工',
	  column: [
	    { label: '员工姓名', prop: 'name', align: 'center'},
			{ label: '身份证号', prop: 'cert', align: 'center'},
	    { label: '手机号', prop: 'phone', align: 'center'},
	  ],
	  search: [
	    { label: '员工姓名', key: 'name'},
	  ],
	  api: '/api/manage/staff/page',
	  id: 'selectCarStaff'
	},
    // 选择私车公用企业出租方
    selectCarLessor: {
        title: '私车公用企业出租方',
        column: [
            { label: '出租方姓名', prop: 'name', align: 'center'},
            { label: '出租方证号', prop: 'certNo', align: 'center'},
            { label: '出租方手机号', prop: 'mobileNo', align: 'center'},
        ],
        search: [
            { label: '出租方姓名', key: 'name'},
        ],
        api: '/api/manage/lessor/page',
        id: 'selectCarLessor'
    },
}
